/* Source: /app/main.jac */
import {__jacJsx, __jacSpawn} from "@jac/runtime";
import { __jacCallFunction } from "@jac/runtime";
import { Index } from "./components/Index.js";
async function load_example_list() {
  return await __jacCallFunction("load_example_list", {});
}
function app() {
  return __jacJsx(Index, {}, []);
}
export {app};